"use strict";

// Do not edit directly
// Generated on Mon, 06 Nov 2023 13:15:14 GMT
exports.__esModule = true;
exports.typography = exports.logo = exports.elevation = exports.color = exports.zindex = exports.spacing = exports.flex = exports.opacity = exports.layout = exports.border = void 0;
exports.border = {
  "radius": {
    "none": 0,
    "xs": "4px",
    "sm": "8px",
    "md": "12px",
    "lg": "24px",
    "pill": "999px",
    "circle": "50%"
  }
};
exports.layout = {
  "xs": {
    "breakpoint": {
      "min": "320px",
      "max": "575px"
    },
    "container": "100%",
    "columns": 4,
    "margin": "24px",
    "gutters": "16px"
  },
  "sm": {
    "breakpoint": {
      "min": "576px",
      "max": "767px"
    },
    "container": "100%",
    "columns": 8,
    "margin": "24px",
    "gutters": "16px"
  },
  "md": {
    "breakpoint": {
      "min": "768px",
      "max": "959px"
    },
    "container": "100%",
    "columns": 8,
    "margin": "40px",
    "gutters": "16px"
  },
  "lg": {
    "breakpoint": {
      "min": "960px",
      "max": "1199px"
    },
    "container": "100%",
    "columns": 12,
    "margin": "40px",
    "gutters": "16px"
  },
  "xl": {
    "breakpoint": {
      "min": "1200px",
      "max": "1439px"
    },
    "container": "1280px",
    "columns": 12,
    "margin": "40px",
    "gutters": "32px"
  },
  "xxl": {
    "breakpoint": {
      "min": "1440px"
    },
    "container": "1600px",
    "columns": 12,
    "margin": "64px",
    "gutters": "32px"
  }
};
exports.opacity = {
  "base": 0.08,
  "base02": 0.16,
  "base03": 0.24,
  "base07": 0.56,
  "base09": 0.72,
  "base11": 0.88
};
exports.flex = {
  "row": {
    "default": {
      "display": "flex",
      "flexDirection": "row",
      "flexWrap": "wrap"
    },
    "centered": {
      "display": "flex",
      "flexDirection": "row",
      "flexWrap": "wrap",
      "justifyContent": "center",
      "alignItems": "center"
    },
    "justifyCenter": {
      "display": "flex",
      "flexDirection": "row",
      "flexWrap": "wrap",
      "justifyContent": "center"
    },
    "justifyStart": {
      "display": "flex",
      "flexDirection": "row",
      "flexWrap": "wrap",
      "justifyContent": "flex-start"
    },
    "justifyEnd": {
      "display": "flex",
      "flexDirection": "row",
      "flexWrap": "wrap",
      "justifyContent": "flex-end"
    },
    "justifySpaceAround": {
      "display": "flex",
      "flexDirection": "row",
      "flexWrap": "wrap",
      "justifyContent": "space-around"
    },
    "justifySpaceBetween": {
      "display": "flex",
      "flexDirection": "row",
      "flexWrap": "wrap",
      "justifyContent": "space-between"
    },
    "alignCenter": {
      "display": "flex",
      "flexDirection": "row",
      "flexWrap": "wrap",
      "alignItems": "center"
    },
    "alignStart": {
      "display": "flex",
      "flexDirection": "row",
      "flexWrap": "wrap",
      "alignItems": "flex-start"
    },
    "alignEnd": {
      "display": "flex",
      "flexDirection": "row",
      "flexWrap": "wrap",
      "alignItems": "flex-end"
    }
  },
  "column": {
    "default": {
      "display": "flex",
      "flexDirection": "column",
      "flexWrap": "wrap"
    },
    "centered": {
      "display": "flex",
      "flexDirection": "column",
      "flexWrap": "wrap",
      "justifyContent": "center",
      "alignItems": "center"
    },
    "justifyCenter": {
      "display": "flex",
      "flexDirection": "column",
      "flexWrap": "wrap",
      "justifyContent": "center"
    },
    "justifyStart": {
      "display": "flex",
      "flexDirection": "column",
      "flexWrap": "wrap",
      "justifyContent": "flex-start"
    },
    "justifyEnd": {
      "display": "flex",
      "flexDirection": "column",
      "flexWrap": "wrap",
      "justifyContent": "flex-end"
    },
    "justifySpaceAround": {
      "display": "flex",
      "flexDirection": "column",
      "flexWrap": "wrap",
      "justifyContent": "space-around"
    },
    "justifySpaceBetween": {
      "display": "flex",
      "flexDirection": "column",
      "flexWrap": "wrap",
      "justifyContent": "space-between"
    },
    "alignCenter": {
      "display": "flex",
      "flexDirection": "column",
      "flexWrap": "wrap",
      "alignItems": "center"
    },
    "alignStart": {
      "display": "flex",
      "flexDirection": "column",
      "flexWrap": "wrap",
      "alignItems": "flex-start"
    },
    "alignEnd": {
      "display": "flex",
      "flexDirection": "column",
      "flexWrap": "wrap",
      "alignItems": "flex-end"
    }
  }
};
exports.spacing = {
  "inner": {
    "base": "4px",
    "base02": "8px",
    "base03": "12px",
    "base04": "16px",
    "base05": "20px",
    "base06": "24px",
    "base08": "32px",
    "base10": "40px",
    "base12": "48px",
    "base14": "56px"
  },
  "layout": {
    "base": "8px",
    "base02": "16px",
    "base03": "24px",
    "base04": "32px",
    "base05": "40px",
    "base06": "48px",
    "base07": "56px",
    "base08": "64px",
    "base10": "80px",
    "base12": "96px",
    "base15": "120px"
  }
};
exports.zindex = {
  "fab": 100,
  "navigation": 200,
  "popover": 300,
  "backdrop": 500,
  "drawer": 510,
  "modal": 520,
  "dialog": 530,
  "modalContent": 550,
  "snackbar": 600,
  "tooltip": 700,
  "aboveAll": 1000
};
exports.color = {
  "background": {
    "primary": "#ffffff",
    "secondary": "#f2f4f8",
    "tertiary": "#dde1e6",
    "inverted": "#191f23",
    "disabled": {
      "main": "#f2f4f8",
      "inverted": "rgba(255, 255, 255, 0.35)"
    },
    "backdrop": "rgba(25, 31, 35, 0.5)",
    "brand": "#003863"
  },
  "feedback": {
    "positive": {
      "main": "#20a483",
      "light": "#e4f0ed"
    },
    "warning": {
      "main": "#ffa600",
      "light": "#fff3de"
    },
    "negative": {
      "main": "#ce4242",
      "light": "#facdcd"
    },
    "informative": {
      "main": "#387ba8",
      "light": "#f2f4f8"
    },
    "neutral": {
      "main": "#697077",
      "light": "#dde1e6"
    }
  },
  "icon": {
    "highlight": {
      "main": "#003863",
      "light": "#20c4f4"
    },
    "primary": "#191f23",
    "muted": "#697077",
    "inverted": "#ffffff",
    "disabled": {
      "main": "#a2a9b0",
      "inverted": "rgba(255, 255, 255, 0.35)"
    }
  },
  "interaction": {
    "link": "#0084b4",
    "primary": {
      "main": "#003863",
      "hover": "#001f35",
      "pressed": "#001f35",
      "border": "#001f35"
    },
    "secondary": {
      "main": "rgba(0, 0, 0, 0)",
      "hover": "rgba(25, 31, 35, 0.1)",
      "pressed": "rgba(25, 31, 35, 0.1)",
      "border": "#191f23"
    },
    "solid": {
      "main": "#ffffff",
      "hover": "#dde1e6",
      "pressed": "#dde1e6",
      "border": {
        "main": "#dde1e6",
        "hover": "#dde1e6",
        "pressed": "#dde1e6"
      }
    },
    "inverted": {
      "main": "#ffffff",
      "hover": "rgba(255, 255, 255, 0.85)",
      "pressed": "rgba(255, 255, 255, 0.85)",
      "border": {
        "main": "#ffffff",
        "hover": "#ffffff",
        "pressed": "#ffffff"
      }
    },
    "invertedSecondary": {
      "main": "rgba(0, 0, 0, 0)",
      "hover": "rgba(255, 255, 255, 0.1)",
      "pressed": "rgba(255, 255, 255, 0.1)",
      "border": {
        "main": "#ffffff",
        "hover": "#ffffff",
        "pressed": "#ffffff"
      }
    },
    "selectors": "#0084b4"
  },
  "separator": {
    "main": "#697077",
    "heavy": "#191f23",
    "light": "#c1c7cd",
    "inverted": "#ffffff",
    "disabled": {
      "main": "#a2a9b0",
      "inverted": "rgba(255, 255, 255, 0.35)"
    }
  },
  "text": {
    "highlight": {
      "main": "#003863",
      "light": "#20c4f4"
    },
    "primary": "#191f23",
    "secondary": "#697077",
    "placeholder": "#878d96",
    "inverted": "#ffffff",
    "disabled": {
      "main": "#a2a9b0",
      "inverted": "rgba(255, 255, 255, 0.35)"
    }
  }
};
exports.elevation = {
  "xs": "0 2px 4px 0 rgba(25,31,35,0.24)",
  "sm": "0 4px 8px 0 rgba(25,31,35,0.2)",
  "md": "0 8px 16px 0 rgba(25,31,35,0.16)",
  "lg": "0 16px 24px 0 rgba(25,31,35,0.12)",
  "xl": "0 24px 32px 0 rgba(25,31,35,0.08)"
};
exports.logo = {
  "primary": {
    "xsmall": {
      "png": "https://content.loft.com.br/copan/credpago/images/logo/primary/xsmall.png",
      "svg": "https://content.loft.com.br/copan/credpago/images/logo/primary/xsmall.svg"
    },
    "small": {
      "png": "https://content.loft.com.br/copan/credpago/images/logo/primary/small.png",
      "svg": "https://content.loft.com.br/copan/credpago/images/logo/primary/small.svg"
    },
    "medium": {
      "png": "https://content.loft.com.br/copan/credpago/images/logo/primary/medium.png",
      "svg": "https://content.loft.com.br/copan/credpago/images/logo/primary/medium.svg"
    },
    "large": {
      "png": "https://content.loft.com.br/copan/credpago/images/logo/primary/large.png",
      "svg": "https://content.loft.com.br/copan/credpago/images/logo/primary/large.svg"
    },
    "icon": {
      "png": "https://content.loft.com.br/copan/credpago/images/logo/primary/icon.png",
      "svg": "https://content.loft.com.br/copan/credpago/images/logo/primary/icon.svg"
    }
  },
  "inverted": {
    "xsmall": {
      "png": "https://content.loft.com.br/copan/credpago/images/logo/inverted/xsmall.png",
      "svg": "https://content.loft.com.br/copan/credpago/images/logo/inverted/xsmall.svg"
    },
    "small": {
      "png": "https://content.loft.com.br/copan/credpago/images/logo/inverted/small.png",
      "svg": "https://content.loft.com.br/copan/credpago/images/logo/inverted/small.svg"
    },
    "medium": {
      "png": "https://content.loft.com.br/copan/credpago/images/logo/inverted/medium.png",
      "svg": "https://content.loft.com.br/copan/credpago/images/logo/inverted/medium.svg"
    },
    "large": {
      "png": "https://content.loft.com.br/copan/credpago/images/logo/inverted/large.png",
      "svg": "https://content.loft.com.br/copan/credpago/images/logo/inverted/large.svg"
    }
  }
};
exports.typography = {
  "variants": {
    "h0": {
      "desktop": {
        "fontFamily": "Uni Neue,Helvetica,Arial,sans-serif",
        "fontSize": "64px",
        "lineHeight": "80px",
        "fontWeight": "700"
      },
      "mobile": {
        "fontFamily": "Uni Neue,Helvetica,Arial,sans-serif",
        "fontSize": "48px",
        "lineHeight": "60px",
        "fontWeight": "700"
      }
    },
    "h1": {
      "desktop": {
        "fontFamily": "Uni Neue,Helvetica,Arial,sans-serif",
        "fontSize": "56px",
        "lineHeight": "68px",
        "fontWeight": "700"
      },
      "mobile": {
        "fontFamily": "Uni Neue,Helvetica,Arial,sans-serif",
        "fontSize": "40px",
        "lineHeight": "48px",
        "fontWeight": "700"
      }
    },
    "h2": {
      "desktop": {
        "fontFamily": "Uni Neue,Helvetica,Arial,sans-serif",
        "fontSize": "48px",
        "lineHeight": "60px",
        "fontWeight": "700"
      },
      "mobile": {
        "fontFamily": "Uni Neue,Helvetica,Arial,sans-serif",
        "fontSize": "32px",
        "lineHeight": "40px",
        "fontWeight": "700"
      }
    },
    "h3": {
      "desktop": {
        "fontFamily": "Uni Neue,Helvetica,Arial,sans-serif",
        "fontSize": "32px",
        "lineHeight": "40px",
        "fontWeight": "700"
      },
      "mobile": {
        "fontFamily": "Uni Neue,Helvetica,Arial,sans-serif",
        "fontSize": "24px",
        "lineHeight": "32px",
        "fontWeight": "700"
      }
    },
    "h4": {
      "desktop": {
        "fontFamily": "Uni Neue,Helvetica,Arial,sans-serif",
        "fontSize": "24px",
        "lineHeight": "32px",
        "fontWeight": "700"
      },
      "mobile": {
        "fontFamily": "Uni Neue,Helvetica,Arial,sans-serif",
        "fontSize": "18px",
        "lineHeight": "28px",
        "fontWeight": "700"
      }
    },
    "hero": {
      "desktop": {
        "fontFamily": "Uni Neue,Helvetica,Arial,sans-serif",
        "fontSize": "64px",
        "lineHeight": "80px",
        "fontWeight": "700"
      },
      "mobile": {
        "fontFamily": "Uni Neue,Helvetica,Arial,sans-serif",
        "fontSize": "48px",
        "lineHeight": "60px",
        "fontWeight": "700"
      }
    },
    "subtitle": {
      "desktop": {
        "fontFamily": "Roboto,Helvetica,Arial,sans-serif",
        "fontSize": "18px",
        "lineHeight": "28px",
        "fontWeight": "700"
      },
      "mobile": {
        "fontFamily": "Roboto,Helvetica,Arial,sans-serif",
        "fontSize": "16px",
        "lineHeight": "24px",
        "fontWeight": "700"
      }
    },
    "paragraphLg": {
      "desktop": {
        "fontFamily": "Roboto,Helvetica,Arial,sans-serif",
        "fontSize": "18px",
        "lineHeight": "28px",
        "fontWeight": "400"
      },
      "mobile": {
        "fontFamily": "Roboto,Helvetica,Arial,sans-serif",
        "fontSize": "16px",
        "lineHeight": "24px",
        "fontWeight": "400"
      }
    },
    "paragraphLgBold": {
      "desktop": {
        "fontFamily": "Roboto,Helvetica,Arial,sans-serif",
        "fontSize": "18px",
        "lineHeight": "28px",
        "fontWeight": "700"
      },
      "mobile": {
        "fontFamily": "Roboto,Helvetica,Arial,sans-serif",
        "fontSize": "16px",
        "lineHeight": "24px",
        "fontWeight": "700"
      }
    },
    "paragraphMd": {
      "desktop": {
        "fontFamily": "Roboto,Helvetica,Arial,sans-serif",
        "fontSize": "16px",
        "lineHeight": "24px",
        "fontWeight": "400"
      },
      "mobile": {
        "fontFamily": "Roboto,Helvetica,Arial,sans-serif",
        "fontSize": "14px",
        "lineHeight": "24px",
        "fontWeight": "400"
      }
    },
    "paragraphMdBold": {
      "desktop": {
        "fontFamily": "Roboto,Helvetica,Arial,sans-serif",
        "fontSize": "16px",
        "lineHeight": "24px",
        "fontWeight": "700"
      },
      "mobile": {
        "fontFamily": "Roboto,Helvetica,Arial,sans-serif",
        "fontSize": "14px",
        "lineHeight": "24px",
        "fontWeight": "700"
      }
    },
    "paragraphSm": {
      "desktop": {
        "fontFamily": "Roboto,Helvetica,Arial,sans-serif",
        "fontSize": "14px",
        "lineHeight": "24px",
        "fontWeight": "400"
      },
      "mobile": {
        "fontFamily": "Roboto,Helvetica,Arial,sans-serif",
        "fontSize": "12px",
        "lineHeight": "20px",
        "fontWeight": "400"
      }
    },
    "paragraphSmBold": {
      "desktop": {
        "fontFamily": "Roboto,Helvetica,Arial,sans-serif",
        "fontSize": "14px",
        "lineHeight": "24px",
        "fontWeight": "700"
      },
      "mobile": {
        "fontFamily": "Roboto,Helvetica,Arial,sans-serif",
        "fontSize": "12px",
        "lineHeight": "20px",
        "fontWeight": "700"
      }
    },
    "caption": {
      "desktop": {
        "fontFamily": "Roboto,Helvetica,Arial,sans-serif",
        "fontSize": "12px",
        "lineHeight": "20px",
        "fontWeight": "400"
      },
      "mobile": {
        "fontFamily": "Roboto,Helvetica,Arial,sans-serif",
        "fontSize": "12px",
        "lineHeight": "20px",
        "fontWeight": "400"
      }
    },
    "overline": {
      "desktop": {
        "fontFamily": "Roboto,Helvetica,Arial,sans-serif",
        "fontSize": "10px",
        "lineHeight": "16px",
        "fontWeight": "700",
        "textTransform": "uppercase"
      },
      "mobile": {
        "fontFamily": "Roboto,Helvetica,Arial,sans-serif",
        "fontSize": "10px",
        "lineHeight": "16px",
        "fontWeight": "700",
        "textTransform": "uppercase"
      }
    },
    "labelSm": {
      "desktop": {
        "fontFamily": "Roboto,Helvetica,Arial,sans-serif",
        "fontSize": "14px",
        "lineHeight": "24px",
        "fontWeight": "400"
      },
      "mobile": {
        "fontFamily": "Roboto,Helvetica,Arial,sans-serif",
        "fontSize": "14px",
        "lineHeight": "24px",
        "fontWeight": "400"
      }
    },
    "labelMd": {
      "desktop": {
        "fontFamily": "Roboto,Helvetica,Arial,sans-serif",
        "fontSize": "16px",
        "lineHeight": "24px",
        "fontWeight": "400"
      },
      "mobile": {
        "fontFamily": "Roboto,Helvetica,Arial,sans-serif",
        "fontSize": "16px",
        "lineHeight": "24px",
        "fontWeight": "400"
      }
    }
  }
};